import Icon from '../../../components/AppIcon';
import { MetricCard } from '../types';

interface MetricsGridProps {
  metrics: MetricCard[];
}

const MetricsGrid = ({ metrics }: MetricsGridProps) => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 mb-6">
      {metrics.map((metric) => (
        <div
          key={metric.id}
          className="bg-card border border-border rounded-md p-6 shadow-elevation-1 hover-scale transition-interactive"
        >
          <div className="flex items-start justify-between mb-4">
            <div
              className="w-12 h-12 rounded-md flex items-center justify-center"
              style={{ backgroundColor: `${metric.color}15` }}
            >
              <Icon name={metric.icon} size={24} color={metric.color} />
            </div>
            <div
              className={`flex items-center gap-1 px-2 py-1 rounded-sm text-xs font-medium ${
                metric.changeType === 'increase' ?'bg-success/10 text-success' :'bg-destructive/10 text-destructive'
              }`}
            >
              <Icon
                name={metric.changeType === 'increase' ? 'TrendingUp' : 'TrendingDown'}
                size={14}
              />
              <span>{Math.abs(metric.change)}%</span>
            </div>
          </div>
          <h3 className="text-sm text-muted-foreground mb-1">{metric.title}</h3>
          <p className="text-2xl font-semibold text-foreground">{metric.value}</p>
        </div>
      ))}
    </div>
  );
};

export default MetricsGrid;